import { schema } from "normalizr";
//import Restrictions from './catalog-restrictions';
import { Catalog as Record } from "records/catalog";

const Catalog = new schema.Entity("catalogs");

Catalog.record = Record;

export default Catalog;
